export const ADDTOCART = "cart/add_to_cart";
export const UPDATECARTQTY = "cart/update_cart_QTY";
export const REMOVEFROMCARTLIST = "cart/remove_from_cart_list";
